export const DISTANCE = 'DISTANCE';
export const AT_CLIENT = 'AT_CLIENT';
export const AT_MASTER = 'AT_MASTER';

export const EXECUTION_LOCATION = [
    {
        id: DISTANCE,
        name: 'Distance'
    },
    {
        id: AT_CLIENT,
        name: 'At client'
    },
    {
        id: AT_MASTER,
        name: 'At master'
    },
]
